import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';

const PaymentFailed = ({ paymentStatus, onRetry }) => {
  const navigate = useNavigate();
  const effectiveStatus = paymentStatus || 'rejected';

  const messages = {
    pending: {
      title: 'Pagamento Pendente',
      description: 'Seu pagamento está em análise. Por favor, aguarde ou verifique sua conta para concluir a transação.',
    },
    rejected: {
      title: 'Pagamento Rejeitado',
      description: 'Houve um problema ao processar seu pagamento. Verifique os dados e tente novamente.',
    },
  };

  const currentMessage = messages[effectiveStatus] || {
    title: 'Erro Desconhecido',
    description: 'Ocorreu um erro inesperado. Tente novamente.',
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{
        background:
          'radial-gradient(circle at top, rgba(96, 26, 26, 0.42) 0%, rgba(7, 12, 18, 1) 55%)',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 400,
          textAlign: 'center',
          borderRadius: 3,
          background: 'linear-gradient(180deg, rgba(16, 24, 33, 0.96) 0%, rgba(10, 16, 23, 0.98) 100%)',
          border: '1px solid rgba(255,255,255,0.12)',
          color: '#E8EEF5',
        }}
      >
        <Typography variant="h5" color="error.main" gutterBottom>
          {currentMessage.title}
        </Typography>
        <Typography sx={{ color: 'rgba(235, 242, 250, 0.82)' }}>{currentMessage.description}</Typography>
        <Box mt={4}>
          <Button
            variant="contained"
            color="error"
            onClick={onRetry || (() => navigate('/painel/pagamento'))}
            sx={{ textTransform: 'none', fontWeight: 700 }}
          >
            Tentar Novamente
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaymentFailed;
